import React from "react";
import _get from "lodash/get";
import moment from "moment-timezone";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { getAccountAuth } from "../../actions/account/accountAdminActions";
import { getProfile } from "../../actions/auth/authActions";
import { updateUserAccount } from "../../actions/account/accountAdminActions";
import { getAccountDetails } from "../../actions/account/accountAdminActions";
import { getResellerById } from "../../actions/reseller/resellerActions";
import UpdateButton from "./UpdateButton";
import { formatDate } from "../../actions/momentActions";
import { getBillInvoice } from "../../actions/adminBillActions";
import * as cookie from "react-cookie";
import { LABELS as _LABELS } from "../../language";
const LABELS = _LABELS.adminPage;

const cookies = new cookie.Cookies();
const styles = (theme) => ({});

function RenderUsers({
  user = {},
  handleLogin,
  accountAuthBusy,
  updateUserAccount,
  getAccountDetails,
  loading,
  testToolApp,
}) {
  const status = _get(user, "status", "");
  let active = false;
  if (status === "ACTIVE") {
    active = true;
  } else {
    active = false;
  }

  return (
    <Grid item xs={12} md={4}>
      <Paper style={{ marginTop: 10, padding: 10 }}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <p
              style={{
                fontWeight: "500",
                fontSize: "15px",
                margin: "0px",
              }}
            >
              {user.firstName} {user.lastName}
            </p>
            <div>
              <small>{user.email}</small>
            </div>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={!testToolApp || accountAuthBusy || loading || !active}
              style={{ margin: "2vh", float: "right" }}
              onClick={(e) => handleLogin(user)}
            >
              {LABELS.logIn}
            </Button>
            <UpdateButton
              active={active}
              accountAuthBusy={accountAuthBusy}
              user={user}
              disabled={!testToolApp}
              updateUserAccount={updateUserAccount}
              getAccountDetails={getAccountDetails}
              label={LABELS.deactivate}
            />
          </Grid>
          <Grid item xs={12} />
        </Grid>
      </Paper>
    </Grid>
  );
}

function RenderDetails(props) {
  // console.log(props.accountData);
  const fD = props.formatDate;
  const accNote = _get(props, "accountData.account.notes", "");
  const plan = _get(props, "accountData.account.plan", []);
  const notes = plan.notes || [];
  const dues = plan.dues || [];

  return (
    <>
      {plan.hold && (
        <Grid item xs={12} md={12}>
          <Alert style={{ width: "100%", marginTop: 10 }} severity="error">
            Account Hold
            <div>{plan.holdReason}</div>
          </Alert>
        </Grid>
      )}
      {accNote && (
        <Grid item xs={12} md={12}>
          <Alert style={{ width: "100%", marginTop: 10 }} severity="info">
            <div>{`Note: ${accNote}`}</div>
          </Alert>
        </Grid>
      )}
      {notes && Array.isArray(notes) && notes.length > 0 && (
        <Grid item xs={12} md={6}>
          <Alert style={{ width: "100%", marginTop: 10 }} severity="info">
            Notes
            {notes &&
              notes.map((item) => (
                <div>{`${item.note} (${fD(item.date)})`}</div>
              ))}
          </Alert>
        </Grid>
      )}
      {dues && Array.isArray(dues) && dues.length > 0 && (
        <Grid item xs={12} md={6}>
          <Alert style={{ width: "100%", marginTop: 10 }} severity="info">
            Dues
            {dues &&
              dues.map((item) => (
                <div>{`${item.truck} ${item.note} is due on ${fD(
                  item.date
                )}`}</div>
              ))}
          </Alert>
        </Grid>
      )}
    </>
  );
}

export class ViewAccountDetail extends React.Component {
  state = {
    loading: true,

    dataLoading: false,
    invoices: [],
  };

  async componentDidMount() {
    const accountId = _get(this, "props.match.params.accountId");
    await this.handleDetails(accountId);
  }

  getBillInvoice = async (customer) => {
    if (customer) {
      customer = customer.replace("SE:", "");
    }
    const response = await this.props.getBillInvoice({ customer });

    if (response && response.data) {
      this.setState({ invoices: response.data });
    }
  };

  handleDetails = async (accountId) => {
    this.setState({ loading: true });
    const selectedAccountData = await this.props.getAccountDetails({
      accountId,
    });
    const resellerId = _get(selectedAccountData, "account.resellerId");
    const stripeBussId = _get(selectedAccountData, "account.stripeBuss");
    if (resellerId) {
      this.handleReseller(resellerId);
    }
    if (this.props.isStripe && stripeBussId) {
      this.setState({ stripeBussId });
      this.getBillInvoice(stripeBussId);
    }

    this.setState({ selectedAccountData, loading: false });
  };

  handleReseller = async (id) => {
    try {
      const reseller = await this.props.getResellerById({ id });
      // console.log("reseller :: ", reseller);
      this.setState({ syncing: false });
    } catch (e) {
      console.log(e);
    }
  };

  handleLogin = async (user) => {
    this.setState({ loading: true });

    const selectedAccountData = this.state.selectedAccountData || {};
    const selectedAccount =
      this.props.selectedAccount && this.props.selectedAccount._id
        ? this.props.selectedAccount
        : selectedAccountData.account || {};

    const accountId = selectedAccount._id;
    const carrierId = selectedAccount.carrierId;
    const terminalId = selectedAccount.terminalId;

    const response = await this.props.getAccountAuth({
      accountId,
      carrierId,
      terminalId,
      userId: user.id,
    });

    cookies.set("token", response.token, {
      path: "/",
      maxAge: 43200,
    });

    await this.props.getProfile();

    this.props.history.push(`/dashboard/${accountId}/status/view`);
    this.setState({ loading: false });
  };

  render() {
    const { classes, accountAuthBusy, testToolApp } = this.props;
    const { loading } = this.state;
    const selectedAccountData = this.state.selectedAccountData || {};
    const selectedAccount = selectedAccountData.account || {};
    const testTool = _get(selectedAccountData, "properties.testTool", {});

    let adminStatus = {
      activeDriver: 0,
      inactiveDriver: 0,
      activeUser: 0,
      inactiveUser: 0,
    };
    let equipStatus = {
      activeVehicle: 0,
      inactiveVehicle: 0,
    };
    if (!selectedAccount) {
      return null;
    }

    const admins = selectedAccountData.admins || [];
    const equipments = selectedAccountData.equipments || [];
    const plan = selectedAccount.plan || {};

    const eqpAllowed = (plan.vehicles && plan.vehicles.allowed) || 0;
    Array.isArray(equipments) &&
      equipments.forEach((item) => {
        if (item.assetType === "VEHICLE") {
          if (item.active) {
            equipStatus.activeVehicle += 1;
          } else {
            equipStatus.inactiveVehicle += 1;
          }
        }
      });

    Array.isArray(admins) &&
      admins.forEach((item) => {
        if (item.role === "DRIVER") {
          if (item.status === "ACTIVE") {
            adminStatus.activeDriver += 1;
          } else {
            adminStatus.inactiveDriver += 1;
          }
        } else {
          if (item.status === "ACTIVE") {
            adminStatus.activeUser += 1;
          } else {
            adminStatus.inactiveUser += 1;
          }
        }
      });

    return (
      <div>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <div id="alert-dialog-title" style={{ textAlign: "center" }}>
              <p
                style={{
                  marginTop: 0,
                  fontWeight: 600,
                  fontSize: "17px",
                }}
              >
                {selectedAccount.name}
              </p>
              {!testToolApp && (
                <Alert severity="warning">
                  This is a real carrier. The test tool is not available for use
                  with this carrier.
                </Alert>
              )}
            </div>

            <div style={{ marginTop: 25 }}>
              {testToolApp && (
                <Grid container spacing={2}>
                  <Grid item md="4">
                    <Typography>
                      TestTool: {testTool.active ? "On" : "Off"}
                    </Typography>
                  </Grid>
                  {testTool.assign && (
                    <Grid item md="4">
                      <Typography>{`Assign: On`}</Typography>
                    </Grid>
                  )}
                  {testTool.change ? (
                    <Grid item md="4">
                      <Typography>{`Change: On`}</Typography>
                    </Grid>
                  ) : null}
                </Grid>
              )}

              <Grid container spacing={2}>
                <RenderDetails
                  accountData={selectedAccountData}
                  formatDate={this.props.formatDate}
                />
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "30px",
                }}
              >
                <Typography>
                  <span>{LABELS.managers}</span>
                </Typography>
              </Grid>
              <Grid container spacing={2}>
                {admins.map((user, i) => {
                  if (user.role !== "MANAGER") {
                    return null;
                  }
                  return (
                    <RenderUsers
                      accountAuthBusy={accountAuthBusy}
                      handleLogin={this.handleLogin}
                      classes={classes}
                      key={i}
                      user={user}
                      changeStatus={this.changeStatus}
                      loading={this.state.loading}
                      getAccountDetails={this.props.getAccountDetails}
                      updateUserAccount={this.props.updateUserAccount}
                      handleClose={this.props.handleClose}
                      testToolApp={this.props.testToolApp}
                    />
                  );
                })}
              </Grid>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const testToolApp = _get(state, "appData.appConfig.testTool", "OFF");
  const testTool = _get(
    state,
    "accountData.selectedAccountData.properties.testTool.active",
    false
  );
  const userRoles = _get(state, "authData.profile.roles", []);
  let isStripe = _get(state, "appData.appConfig.isStripe", "OFF") === "ON";

  if (userRoles.includes("PARTNER")) {
    isStripe = false;
  }

  return {
    isStripe,
    testToolApp: testToolApp && testTool,
    accountBaseUrl: _get(state, "authData.accountBaseUrl"),
    selectedAccount: _get(state, "accountData.selectedAccount", {}),
    accountAuthBusy: _get(state, "accountData.accountAuthBusy", false),
    selectedAccountData: _get(state, "accountData.selectedAccountData", {}),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAccountAuth,
      getProfile,
      updateUserAccount,
      getAccountDetails,
      formatDate,
      getResellerById,
      getBillInvoice,
    },
    dispatch
  );

export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewAccountDetail))
);
